<div class="chat-overlay-container">
  <div
    #chatPanel
    class="chat-panel"
    [class.visible]="isOpen()"
    mwlResizable
    [style.width.px]="panelWidth()"
    [style.height.px]="panelHeight()"
    (resizing)="onResize($event)"
  >
    <div class="resize-handle-top" mwlResizeHandle [resizeEdges]="{ top: true }"></div>
    <div class="resize-handle-left" mwlResizeHandle [resizeEdges]="{ left: true }"></div>
    <div
      class="resize-handle-corner"
      mwlResizeHandle
      [resizeEdges]="{ top: true, left: true }"
    ></div>

    <chat-window #chatEl></chat-window>
  </div>


  <button
    class="chat-toggle-btn"
    [class.chat-toggle-btn--open]="isOpen()"
    (click)="toggleOpen()"
    [attr.aria-label]="isOpen() ? 'Close chat' : 'Open AI Assistant'"
    [attr.aria-expanded]="isOpen()"
  >
    <span class="chat-toggle-btn__icon">
      @if (isOpen()) {
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
          <path d="M20 3v4"/>
          <path d="M22 5h-4"/>
          <path d="M4 17v2"/>
          <path d="M5 18H3"/>
        </svg>
      }
    </span>
    <span class="chat-toggle-btn__label">{{ isOpen() ? 'Close' : 'AI Assistant' }}</span>
  </button>
</div>
